








































import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { BookApi } from "@/api/bookApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class BookList extends Vue {
  bookApi = new BookApi();
  dataList: Array<object> = [];
  pageNum = 1;
  listTotal = 0;

  mounted() {
    this.getUserInfo();
  }

  getUserInfo() {
    this.bookApi.getBookList(this.pageNum, 9).then((res) => {
      this.dataList = res.data;
      this.listTotal = res.total;
    });
  }
}
